const defaultFillWidth = 100 / 7
export const onBoardingModule = {
  namespaced: true,
  state: () => ({
    isMobile: window.innerWidth < 700,
    regEmail: '',
    ob_step: 1,
  }),
  mutations: {
    updateEmail(state, payload) {
      state = { ...state, regEmail: payload }
    },
    setObStep(state, payload) {
      state.ob_step = payload
    },
  },
  getters: {
    getMobileMode(state) {
      return state.isMobile
    },
    getEmailAddress(state) {
      return state.regEmail
    },
    getName(state) {
      return state.myName
    },
    getProgFillWidth(state) {
      switch (state.ob_step) {
        case 1:
          return `${defaultFillWidth * state.ob_step}%`
        case 2:
          return `${defaultFillWidth * state.ob_step}%`
        case 3:
          return `${defaultFillWidth * state.ob_step}%`
        case 4:
          return `${defaultFillWidth * state.ob_step}%`
        case 5:
          return `${defaultFillWidth * state.ob_step}%`
        case 6:
          return `${defaultFillWidth * state.ob_step}%`
        case 7:
          return '100%'
        default:
          break
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/ob.module.js